import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { OutlinedBadge } from "lib/@components/outlined-badge"
import { If } from "lib/@components/switch"
import { useMemo } from "react"

export function AssetFiltersCountLabel({ isOpen }) {
    const { filters } = useBoundContext()
    const filtersCount = useMemo(
        () => Object.values(filters ?? {}).reduce((sum, arr) => sum + arr.length, 0),
        [filters]
    )

    return (
        <If value={!isOpen}>
            <OutlinedBadge color="primary.main" content={filtersCount} sx={{ ml: 1, mr: 1 }} />
        </If>
    )
}
